import React, { createContext, useContext, useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth, db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";

export const AuthContext = createContext({
  currentUser: null,
  firstName: null,
  loading: true,
});

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [firstName, setFirstName] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Listen to Firebase auth changes
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      setCurrentUser(user || null);
      setFirstName(null);

      if (user) {
        try {
          const snap = await getDoc(doc(db, "users", user.uid));
          if (snap.exists()) {
            const data = snap.data();
            setFirstName(data.firstName || null);
          }
        } catch (e) {
          console.error("AuthContext: failed to load user profile", e);
        }
      }

      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const value = { currentUser, firstName, loading };
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

// Handy hook
export const useAuth = () => useContext(AuthContext);
